// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { tablet16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-tablet': IconTablet;
    }
}

/**
 * The icon component for the 'tablet' icon
 */
export class IconTablet extends Icon {
    public constructor() {
        super(tablet16X16);
    }
}

registerIcon('icon-tablet', IconTablet);
export const iconTabletTag = 'nimble-icon-tablet';
